import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { BaseFormService } from '../BaseFormService';
import { UtilityService } from '../utility.service';

@Injectable({
	providedIn: 'root',
})
export class LocationService extends BaseFormService {
	constructor(httpClient: HttpClient, utilityService: UtilityService) {
		super(`${environment.apiUrl}inventory/clients/$$clientId$$/location`, httpClient, utilityService);
	}
	submitForApproval(clientId: string, id: any, userId: string): Observable<any> {
		return this.httpClient
			.post<any>(`${this.getUrl(clientId)}/${id}/approval`, {
				userId,
			})
			.pipe();
	}
	inActiveLocation(clientId: string, id: any) {
		return this.httpClient.delete(`${this.getUrl(clientId)}/${id}/delete`).pipe();
	}
	import(clientId: string, locations: any[]): Observable<any> {
		return this.httpClient.post<any>(`${this.getUrl(clientId)}/import`, locations).pipe();
	}
}
